import { Tooltip, Typography } from "@material-ui/core";
import { darken, styled } from "@material-ui/core/styles";
import EcoIcon from "@material-ui/icons/Eco";
import PropTypes from "prop-types";
import React from "react";

const StyledBox = styled("div")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  background: "linear-gradient(90deg, #e3f2fd 40%, #bbdefb 100%)",
  border: `1.5px solid ${darken("#bbdefb", 0.1)}`,
  borderRadius: theme.spacing(3),
  padding: theme.spacing(1, 2),
  boxShadow: "0 2px 6px rgba(25, 118, 210, 0.10)",
  minWidth: 0,
  gap: theme.spacing(1),
}));

const StyledIcon = styled(EcoIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: 22,
  opacity: 0.7,
}));

const StyledText = styled("p")(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.primary.main,
  whiteSpace: "nowrap",
  margin: 0,
  fontWeight: 700,
}));

export default function CharityBadge({ charityName }) {
  return (
    <Tooltip
      title={
        <React.Fragment>
          <Typography variant="subtitle2" color="inherit">
            Items purchased from this Talent will help support {charityName}.
          </Typography>
        </React.Fragment>
      }
      placement="bottom"
      arrow
    >
      <StyledBox>
        <StyledIcon />
        <StyledText>Supporting &nbsp;{charityName}</StyledText>
      </StyledBox>
    </Tooltip>
  );
}

CharityBadge.propTypes = {
  charityName: PropTypes.string.isRequired,
};
